// src/pages/item_deliveries/ItemDeliveryForm.js
import {
  Box,
  Button,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import AdminHeader from '../../components/AdminHeader';
import LayoutContainer from '../../components/LayoutContainer';
import itemService from '../../services/itemService';
import stationService from '../../services/stationService';
import { find, isEmpty, map } from 'lodash';
import moment from 'moment';
import userService from '../../services/userService';
import locationService from '../../services/locationService';
import eventService from '../../services/eventService';
import allotedItemsService from '../../services/allotedItemsService';
import { toast } from 'react-toastify';

const InwardForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [stations, setStations] = useState([]);
  const [users, setUsers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [events, setEvents] = useState([]);
  const [initialValues, setInitialValues] = useState({
    user_id: localStorage?.getItem('user_id'),
    item_id: '',
    inward_qty: '',
    location_id: '',
    event_id: localStorage?.getItem('event_id'),
    // timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
  });

  useEffect(() => {
    const fetchItemDelivery = async () => {
      if (id) {
        const response = await allotedItemsService.getAllotedItem(id);
        setInitialValues(response.data);
      }
    };
    fetchItemDelivery();
  }, [id]);

  const fetchUsers = async () => {
    const response = await userService.getUsers();
    setUsers(response.data);
  };

  const fetchLocations = async () => {
    const response = await locationService.getLocations();
    setLocations(response.data);
  };

  const fetchEvents = async () => {
    const response = await eventService.getEvents();
    setEvents(response.data);
  };

  useEffect(() => {
    fetchEvents();
    fetchLocations();
    fetchUsers();
  }, []);

  const validationSchema = Yup.object().shape({
    item_id: Yup.number().required('Item is required'),
    inward_qty: Yup.number()
      .required('Inward Quantity is required')
      .min(1, 'Inward Quantity must be greater than zero'),
    // station_id: Yup.number().required('Station is required'),
    location_id: Yup.number().required('Location is required'),
    // event_id: Yup.number().required('Event is required'),
    // user_id: Yup.number().required('User is required'),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (id) {
        await allotedItemsService.updateAllotedItem(id, [values]);
      } else {
        await allotedItemsService.createAllotedItem([values]);
      }
      navigate('/inward-items');
    } catch (error) {
      console.error(error); // Handle error appropriately
    } finally {
      setSubmitting(false);
    }
  };

  const fetchItems = async () => {
    try {
      const response = await itemService.getItemsByEventId();
      setItems(response.data);
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  // const fetchStations = async () => {
  //   const response = await stationService.getStations();
  //   setStations(response.data);
  // };

  useEffect(() => {
    fetchItems();
    // fetchStations();
  }, []);

  const labelStyle = {
    color: '#000',
    fontSize: '0.87rem',
    marginTop: 8,
  };

  return (
    <LayoutContainer>
      <AdminHeader
        title={id ? 'EDIT INWARD ITEM' : 'ADD INWARD DELIVERY'}
        backTo='/inward-items'
      />
      <div className='page-content-wrapper scrollable'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Item</div>
                <Select
                  name='item_id'
                  value={values.item_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(items) ? (
                    map(items, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.item_name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.item_id && errors.item_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.item_id}
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Inward Quantity</div>
                <TextField
                  name='inward_qty'
                  fullWidth
                  type='number'
                  value={values.inward_qty}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.inward_qty && errors.inward_qty && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.inward_qty}
                  </FormHelperText>
                )}
              </Box>
              {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Station</div>
                <Select
                  name='station_id'
                  value={values.station_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(stations) ? (
                    map(stations, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.station_name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.station_id && errors.station_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.station_id}
                  </FormHelperText>
                )}
              </Box> */}
              {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>User</div>
                <Select
                  name='user_id'
                  value={values.user_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(users) ? (
                    map(users, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.username}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.user_id && errors.user_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.user_id}
                  </FormHelperText>
                )}
              </Box> */}
              {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Events </div>
                <Select
                  name='event_id'
                  value={values.event_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(events) ? (
                    map(events, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.event_id && errors.event_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.name}
                  </FormHelperText>
                )}
              </Box> */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Location</div>
                <Select
                  name='location_id'
                  value={values.location_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(locations) ? (
                    map(locations, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.location_name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.location_id && errors.location_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.location_id}
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                  type='submit'
                  variant='contained'
                  sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
                >
                  {id ? 'Update' : 'Create'}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </LayoutContainer>
  );
};

export default InwardForm;
